<template>
  <div class="">
    <introduce />
  </div>
</template>

<script>
import introduce from "./introduce.vue";
export default {
  components: { introduce },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped></style>
